<template>
  <div id="app">
      <van-loading type="spinner" v-show="loading"/>
     <!-- <keep-alive> -->
      <router-view />
     <!-- </keep-alive>
      <player></player> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  mounted(){
    console.log(this.$root,'###')
  },
  components: {
  },

  computed: {
    ...mapGetters(["loading"])
  },

};
</script>

<style lang="less">
img {
  pointer-events: none;
}
.van-loading {
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
</style>




// WEBPACK FOOTER //
// src/App.vue